__turbopack_context__.v({
  "root": "pKiNka_root",
});
